import React from 'react';
import { Card } from '../ui/Card';
import { FileIcon, PaperclipIcon, DownloadIcon, TrashIcon, PlusIcon } from 'lucide-react';
export function AttachmentsTab() {
  return <div data-id="element-76">
      <Card title="Attachments" data-id="element-77">
        <div className="mb-4" data-id="element-78">
          <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md mb-2" data-id="element-79">
            <div className="flex items-center gap-3" data-id="element-80">
              <FileIcon className="w-5 h-5 text-blue-500" data-id="element-81" />
              <div data-id="element-82">
                <p className="font-medium" data-id="element-83">contract_2023.pdf</p>
                <p className="text-xs text-gray-500" data-id="element-84">
                  Added Oct 10, 2023 • 2.4 MB
                </p>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-85">
              <button className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-86">
                <DownloadIcon className="w-4 h-4" data-id="element-87" />
              </button>
              <button className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-gray-100 rounded-md" data-id="element-88">
                <TrashIcon className="w-4 h-4" data-id="element-89" />
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between p-3 border border-gray-200 rounded-md" data-id="element-90">
            <div className="flex items-center gap-3" data-id="element-91">
              <FileIcon className="w-5 h-5 text-green-500" data-id="element-92" />
              <div data-id="element-93">
                <p className="font-medium" data-id="element-94">invoice_1001.xlsx</p>
                <p className="text-xs text-gray-500" data-id="element-95">
                  Added Sep 15, 2023 • 1.1 MB
                </p>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-96">
              <button className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-97">
                <DownloadIcon className="w-4 h-4" data-id="element-98" />
              </button>
              <button className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-gray-100 rounded-md" data-id="element-99">
                <TrashIcon className="w-4 h-4" data-id="element-100" />
              </button>
            </div>
          </div>
        </div>
        <div className="mt-4" data-id="element-101">
          <button className="flex items-center gap-1.5 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-102">
            <PaperclipIcon className="w-4 h-4" data-id="element-103" />
            <span data-id="element-104">Add Attachment</span>
          </button>
        </div>
      </Card>
    </div>;
}